import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    VATTitle: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.vat_title',
        defaultMessage:
            '<strong>Business VAT Return</strong> for the last {quantifier} {quantifier_unit}'
    },
    VATBulletOne: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.vat_bullet_one',
        defaultMessage:
            'We accept PDF statements downloaded from either {link} or from your accounting software'
    },
    VATPortalLinkText: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.hmrc_portal_link_text',
        defaultMessage: 'the HMRC portal'
    },
    VATBulletTwo: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.vat_bullet_two',
        defaultMessage: 'Need help? Check out our VAT return guide {link}'
    },
    VATGuideLinkText: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.vat_guide_link_text',
        defaultMessage: 'here'
    },
    CompanyAccountsTitle: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.company_accounts_title',
        defaultMessage:
            '<strong>Filed company accounts</strong> for the last {quantifier}'
    },
    CompanyAccountsInfo: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.company_accounts_info',
        defaultMessage:
            'Your last set of filed accounts, in a PDF format. This should be the full version of the accounts including profit and loss and balance sheet, broken down by item.'
    },
    ManagementAccountsTitle: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.management_accounts_title',
        defaultMessage: '<strong>Current management accounts</strong>'
    },
    ManagementAccountsInfo: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.management_accounts_info',
        defaultMessage:
            'These could be whatever your business uses to aid forecasting, spending and budgeting.'
    },
    SelfAssessmentTaxReturnTitle: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.self_assessment_tax_return_title',
        defaultMessage: '<strong>Self Assessment Tax Return</strong>'
    },
    SelfAssessmentTaxReturnInfo: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.self_assessment_tax_return_info',
        defaultMessage: 'Please upload your self assessed tax return'
    },
    AgedDebtorReportTitle: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.aged_debtor_report_title',
        defaultMessage: '<strong>Aged Debtor Report</strong>'
    },
    AgedDebtorReportInfo: {
        id: '_.apply_flexi_loan.newDocUploads.requirement_types.aged_debtor_report_info',
        defaultMessage:
            'This should be a list of invoices you have issued but are yet to be paid, and ideally grouped by the number of days outstanding e.g. (30, 60, 90+ days).'
    }
});
